import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FirestoreOrgaUser, OrgaUserPermission } from '@jessie/commons';
import { OrgaUserService } from '../../../../../services/orga-user.service';
import { DropdownItemComponent } from '../../../../../components/dropdown-minimal-menu/dropdown-item/dropdown-item.component';
import { NgIconWrapperComponent } from '../../../../../components/icons/ng-icon-wrapper/ng-icon-wrapper.component';
import { DropdownButtonComponent } from '../../../../../components/dropdown-minimal-menu/dropdown-button/dropdown-button.component';
import { DropdownMinimalMenuComponent } from '../../../../../components/dropdown-minimal-menu/dropdown-minimal-menu.component';


@Component({
    selector: 'app-orga-user-card',
    templateUrl: './orga-user-card.component.html',
    imports: [
    DropdownMinimalMenuComponent,
    DropdownButtonComponent,
    NgIconWrapperComponent,
    DropdownItemComponent
],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrgaUserCardComponent {
  @Input()
  orgaUser!: FirestoreOrgaUser;
  @Input()
  role!: OrgaUserPermission;

  constructor(private orgaUserService: OrgaUserService) {}

  deleteOrgaUser(): void {
    if (this.orgaUser.data.role !== 'owner') {
      this.orgaUserService.deleteOrgaUser(this.orgaUser);
    }
  }
}
